import { Stack, Text } from '@mantine/core';
import Indicator from '../../riskindicators/Indicator';
import PasswordComplexity from '../components/PasswordComplexity';
import RouterLink from '@/components/content/link/RouterLink';

import { createHelper } from '../../issue/utils/helper';
import { CREDENTIALS_EXPOSURE_TYPE_MAP } from '../types';

import type { NormalizedSignal } from '@/services/unifiedapi';
import type { Module } from '../../issue/types/modulesv2';

const helper = createHelper<NormalizedSignal>();

export const signalCredentiasExposureDrawer = (): Array<Module<NormalizedSignal>> => [
  {
    submodules: [
      helper.accessor((data) => data.credential.username, {
        element: ({ getValue }) => (
          <Stack gap={10} align="center" justify="center">
            <Text fw="bold" ta="center">
              {getValue()}
            </Text>
            <Text size="sm">Identity Leak</Text>
          </Stack>
        ),
      }),
    ],
  },
  {
    submodules: [
      helper.accessor((data) => data.credential.type, {
        title: 'Risk Indicators',
        element: ({ getValue }) => {
          return <Indicator hasIndicator={true} text={CREDENTIALS_EXPOSURE_TYPE_MAP[getValue()]} />;
        },
        scroll: false,
      }),
    ],
  },
  {
    title: 'Credentials Leak Information',
    submodules: [
      helper.accessor((data) => data.credential.domain, {
        title: 'Associated domains',
      }),
      helper.accessor((data) => data.attributes.email, {
        title: 'Exposed Email',
      }),
      helper.accessor((data) => data.credential.leaked_password, {
        title: 'Leaked Password',
      }),
      helper.accessor((data) => data.credentials, {
        title: 'Leaked Password Complexity',
        element: ({ getValue }) => {
          return <PasswordComplexity {...getValue()} />;
        },
      }),
      helper.accessor((data) => data.credential.hash, {
        title: 'Password SHA256',
      }),
      helper.accessor((data) => data.credential.hostname, {
        title: 'Related hostname',
      }),
      helper.accessor((data) => data.attributes.ip, {
        title: 'Exposed IP',
      }),
      helper.accessor((data) => data.credential.url, {
        title: 'URL of Login',
      }),
      helper.accessor(
        (data) =>
          data.catalog.source && data.catalog.source.length
            ? { names: data.catalog.source, ids: data.catalog.source_id }
            : null,
        {
          title: 'Source',
          element: ({ getValue }) => {
            const { names, ids } = getValue();

            return names.map((source: string, i: number) => (
              <RouterLink to={`/catalogs/sources/entity/${ids[i]}`} key={i}>
                {source}
              </RouterLink>
            ));
          },
        }
      ),
    ],
  },
];
